import { css } from '@emotion/react'

const reset = css`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  html {
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
    box-sizing: border-box;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: normal;
    font-size: 1rem;
    scroll-padding-top: 80px;
  }
  body {
    margin: 0;
    padding: 0;
  }
  [tabindex='-1']:focus {
    outline: none !important;
  }
  pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
  }
  figure {
    margin: 0 0 1rem 0;
  }
  img {
    vertical-align: middle;
  }
  [role='button'] {
    cursor: pointer;
  }
  a,
  area,
  button,
  [role='button'],
  input,
  label,
  select,
  summary,
  textarea {
    touch-action: manipulation;
  }
  table {
    border-collapse: collapse;
    background-color: #fff;
  }
  caption {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    color: #fff;
    text-align: center;
    caption-side: bottom;
  }
  th {
    text-align: left;
  }
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }
  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }
  input,
  button,
  select,
  textarea {
    line-height: inherit;
  }
  input[type='date'],
  input[type='time'],
  input[type='datetime-local'],
  input[type='month'] {
    -webkit-appearance: listbox;
  }
  textarea {
    resize: vertical;
  }
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }
  legend {
    display: block;
    width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: inherit;
  }
  input[type="search"] {
    -webkit-appearance: none;
  }
  output {
    display: inline-block;
  }
  svg:not(:root) {
    overflow: hidden;
    vertical-align: middle;
  }
  [hidden] {
    display: none !important;
  }
  li#flexSubMenuGroup.rc-menu-item-group > .rc-menu-item-group-title {
    border-bottom: 0px solid #dedede;
  }
  li#flexSubMenuGroup.rc-menu-item-group > .rc-menu-item-group-list {
    display: flex;
    border: none;
    list-style-type: none;
    ul {
      list-style-type: none;
    }
    padding-bottom: 2rem;
  }
  li.customDivider {
    height: 220px;
    width: 0.1px;
    margin: 1rem -2.81rem 1rem -1.95rem;
  }
  li#columnMenuGroup.rc-menu-item-group > .rc-menu-item-group-title {
    padding: 0px;
  }
  li#menuGroup.rc-menu-item-group > .rc-menu-item-group-title {
    padding: 0px;
  }
  .rc-menu-horizontal > .rc-menu-submenu > .rc-menu-submenu-title {
    border-radius: 2px;
  }
  .rc-menu-submenu.rc-menu-submenu-popup {
    z-index: 1040 !important;
    padding-top: 3rem;
    @media (max-width: 900px) {
      left: 30px !important;
    }
  }
  .rc-menu-item.rc-menu-item-active {
    border-radius: 2px;
  }
  .ReactModal__Body--open {
    overflow-y: hidden !important;
    position: fixed !important;
    width: 100%;
  }
  .rc-menu{
    border:none;
  }
  .rc-menu-horizontal > .rc-menu-item, .rc-menu-horizontal > .rc-menu-submenu > .rc-menu-submenu-title{
    padding: 0px !important;
  }
  rc-menu-submenu rc-menu-submenu-horizontal{
    margin-right:-3rem;
  }
  .rc-menu-submenu > .rc-menu{
    border-radius: 0.4375rem;
    border: 1px solid #E8E8E9;
  }
  .image-view {
    max-width: 100%;
  }
  .aa-item {
    background-color: #fce6ff;
  }
  .aa-Panel {
    border: 1px solid #d2d1d2;
    border-radius: 0.5rem;
  }
  .aa-PanelLayout {
    li[aria-selected=true] {
      background-color: #fce6ff;
    }
    li {
      border-radius: 2px;
      mark {
        color: #1c1b1f;
      }
    }
  }
  .rc-menu-horizontal:after {
    display: none;
  }
`

export default reset
